module.exports = __webpack_public_path__ + "img/vf4.3f9c20bf.png";